import DF from "./DateFormat";

export let beeId = "";
export let groupId = "";
export let roomId = "";
export let deviceId = "";
export let clientId = "web/9001031"

export const ComponentType = {
  SYSTEM:"system",
  ENTERPRISE:"enterprise",
  CUSTOM:"custom",
  IMAGE:"image"
}

export const Link = {
  MQTT : "mqtt",
  WEBSOCKET : "websocket",
  HTTP : "http"
}

export const Extreme = {
  MAX : "max",
  MIN : "min",
  AVG : "avg",
  MD: "maxDemand"
}

export const TimeScale = {Minute: "K5", Hour: "K60", Day: "D1", Week: "W1", Month: "M1", Year: "Y1",
      s:"s",m:"m",H:"H",d:"d",w:"w",M:"M",y:"y",decade:"decade"};
export const callbacks = {};
export const ChartStyle = {
  ColorMap: ["#FF0000", "#FF7D00", "#FFFF00", "#00FF00", "#00FFFF", "#0000FF", "#FF00FF"],
  default: {
    chartTitle: "",
    subTitleText: "",
    subTitleAligh: "",
    subTitleFontSize: "",
    yTitleText: "",
    categories: [],
    FMT: "HH:mm",
    unit: "",
    bgColor: '#000000',
    chartHeight: '400px',
    legendEnable: false,
  },
  doubleOrdinate: { //双纵坐标
    title: "",
    subTitleText: "",
    subTitleAligh: "",
    yTitleText: "",
    FMT: "HH:mm",
    unit: "",
    yAxisMap: "",
    bgColor: 'rgba(0,0,0,0)'
  },
  dateTime: {}
};
export const ChartType = {
  AREA: "AreaChart",  //面积图
  AREARANGE: "AreaRangeChart", //面积范围图
  AREASPLINE: "AreaSplineChart", //面积曲线图
  AREASPLINERANGE: "AreaSplineRangeChart", //面积曲线范围图
  BAR: "BarChart", //条形图
  BOXPLOT: "BoxPlotChart", //箱线图
  BUBBLE: "BubbleChart", //气泡图
  COLUMN: "ColumnChart", //柱状图
  COLUMNRANGE: "ColumnRangeChart", //柱状范围图
  ERRORBAR: "ErrorBarChart", //误差线图
  FUNNEL: "FunnelChart", //漏斗图
  GAUGE: "GaugeChart", //仪表图
  HEATMAP: "HeatMapChart", //热力图
  HYBRID: "Hybrid", //混合图
  LINE: "LineChart", //曲线图
  PIE: "PieChart", //饼图
  POLYGON: "PolygonChart", //多边形图
  SCATTER: "ScatterChart", //散点图
  SERIES: "SeriesChart", //通用数据列
  SPLINE: "SplineChart",  //曲线图
  STREAM: "StreamChart", //流图
  TREEMAP: "TreeMapChart", //树状图
  WATERFALL: "WaterfallChart", //瀑布图
  SANKEY: "Sankey"
};

export const TopicSet = {
  QUERY_SUB: "eig/query_/clientId/messageId",
  QUERY_PUB: "eig/query/eig-main/beeId/query3",
  FORECAST_SUB:"eig/forecast_/clientId/messageId",
  FORECAST_PUB:"eig/forecast/eig-main/beeId/forecast3",
  SYNC_SUB:"eig/query_/clientId/eig-main/beeId",
  SYNC_PUB:"eig/query/eig-main/beeId/sync2",
  CLIENT_SUB:"node/anyone_/clientId/messageId",
  CLIENT_PUB:"node/anyone",
  CONTROL_SUB: "eig/terminalCommand_/clientId/messageId",
  CONTROL_PUB: "eig/terminalCommand/deviceId/beeId"
}
export const Rtype = {
  ToValue:"toValue",
  ToJsonArray:"toJsonArray",
  ToVArray:"toArray",
  ToAxis:"toAxis",
  ToList:"toList",
  ToJson:"toJson",
  ToAssignList:"toAssignList"
}
export const QType = {
  STATE:"state",
  CURVE:"curve",
  FORECAST:"forecast",
  LOG:"log",
  K:"K",
  FRIEND:"friend",
  AMBIENT:"ambient",
  SWITCH:"switch"
}

export const RULE = {
  STATE_RULE:"state.Vtype:Utype",
  SWITCH_RULE:"state.SwitchState:Utype",
  TriState_RULE:"state.VtypeA:Utype;state.VtypeB:Utype;state.VtypeC:Utype",
  CURVE_RULE:"curve.Utype.TimeScale.Vtype:dateRange",
  TriCurve_RULE:"curve.Utype.VtypeA:dateRange;curve.Utype.VtypeB:dateRange;curve.Utype.VtypeC:dateRange",
  FORECAST_RULE:"",
  LOG_RULE:"",
  K_RULE:"K.ambient-beeId.TimeScale.Vtype:TopX",
  FRIEND_RULE:"myFriends:beeId",
  AMBIENT_RULE:"ambient-beeId.Utype:uid",
}

export const Utype = {
  PE_GATEWAY:"peGateway",
  PE_ROOM:"peRoom",
  PE_SOCKET:"peSocket",
  PE_AMMETER:"peAmmeter",
  PE_DT_AMMETER:"peDtAmmeter",
  PE_Hum:"peHum",
  PE_CLOCK:"peClock",
  PE_LIGHT:"peLight",
  PE_DOUBLE_LIGHT:"peDbLight",
  PE_TRIPLE_LIGHT:"peTpLight",

  DT_GATEWAY:"dtGateway",
  DT_ROOM:"dtRoom",
  DT_SOCKET:"dtSocket",
  DT_AMMETER:"dtAmmeter",
  DT_DT_AMMETER:"dtDtAmmeter",
  DT_CLOCK:"dtClock",
  DT_LIGHT:"dtLight",
  DT_DOUBLE_LIGHT:"dtDbLight",
  DT_TRIPLE_LIGHT:"dtTpLight",

  VE_AMMETER:"veAmmter",
  VE_DT_AMMETER:"veDtAmmeter",
  VE_LIGHT:"veLight",
  VE_DOUBLE_LIGHT:"veDbLight",
  VE_TRIPLE_LIGHT:"veTpLight",
  VE_SOCKET:"veSocket",
  VE_IRC:"veIrc",
  VE_NO1:"veNo1",
  VE_NO2:"veNo2",
  VE_NO3:"veNo3",
  VE_NO4:"veNo4",
  VE_NO5:"veNo5",
  VE_NO6:"veNo6",
  VE_NO7:"veNo7",
  VE_NO8:"veNo8",
  VE_NO9:"veNo9",
  VE_METRY:"veTelemetry",
  VE_SIGNAL:"veTelesignalling",

  CE_ROBOT:"ceRobot",

  OE_CLOCK:"oeClick",
  OE_COUNTER:"oeCounter",

  GATEWAY: "gateway",
  ROOM: "room",
  TERMINAL: "device",
  VIRTUAL:"virtual",
  TriUnit:"triunit",
  SOCKET: "Sck",
  VIRTUAL_SOCKET:"v_Sck",
  LIGHT: "Lk1",
  VIRTUAL_LIGHT:"v_Sck",
  DOUBLE_LIGHT: "Lk2",
  VIRTUAL_DLIGHT:"v_Sck",
  TRIPLE_LIGHT: "Lk3",
  VIRTUAL_TLIGHT:"v_Sck",
  AMMETER: "Trm",
  VIRTUAL_AMMETER:"v_Sck",
  // DT_AMMETER: "Trm-at",
  VIRTUAL_DTAMMETER:"v_Sck",
  IRC: "Irc",
  VIRTUAL_IRC:"v_Irc",
  IRS: "Irs",
  VIRTUAL_IRS:"v_Irs",
  NONE: "none",
  DATE:"date",
  CLOCK:"clock",
  COUNTER:"counter",
  VIRTUAL_ROBOT:"v_robot"
};
export const UtypeName = {
  gateway:"网关",
  room:"房间",
  device:"设备",
  virtual:"虚拟设备",
  date:"时间",
  counter:"计数器"
}


export const Vtype = {
  E: "Energy",
  P: "P",
  U: "U",
  I: "I",
  PF: "PowerFactor",
  PA: "PA",
  PB: "PB",
  PC: "PC",
  Ps: "Ps",
  UA: "UA",
  UB: "UB",
  UC: "UC",
  Us: "Us",
  IA: "IA",
  IB: "IB",
  IC: "IC",
  Is: "Is",
  TriPhase:"TriPhase",
  Factor: "Factor",
  PFA: "FactorA",
  PFB: "FactorB",
  PFC: "FactorC",
  PFs: "PFs",
  METER: "meters",
  F: "F",
  T: "Temperature",
  BEE: "beeId",
  HUMI: "Humi",
  ILLUM:"Illumination01",
  SwitchState: "SwitchState",
  DR: "demandResponse",
  Conn:"connection",
  Control: "controlled",
  Scene: "instr-beeId_10013",
  Cron: "instr-beeId_10012"
};

export const VirtualDataSource = {
  VIRTUAL_SEQ_DATA:'virtualSeqData',
  VIRTUAL_METER:'virtualMeter',
  VIRTUAL_SIGNAL:'virtualSignal',
  VIRTUAL_RATIO:'virtualRatio',
  VIRTUAL_2_STATE:'virtual_2_State',
  VIRTUAL_3_STATE:'virtual_3_State',
  VIRTUAL_4_STATE:'virtual_4_State',
  VIRTUAL_5_STATE:'virtual_5_State',
  VIRTUAL_6_STATE:'virtual_6_State',
  VIRTUAL_7_STATE:'virtual_7_State',
}

export const QDefSets = {
  STATEP:"state.P",
  STATEU:"state.U",
  STATEI:"state.I",
  CURVEP:"curve.P",
  CURVEU:"curve.U",
  CURVEI:"curve.I",
  CURVEK60E:"curve.K60.Energy",
  CURVED1E:"curve.D1.Energy",
  CURVEW1E:"curve.W1.Energy",
  CURVEM1E:"curve.M1.Energy",
  CURVEY1E:"curve.Y1.Energy",
  AMBIENTROOMS:"ambient.rooms",
  AMBIENTTERMINALS:"ambient.terminals",
}

export const QDefValue = {
  "state.P":{beeId:'',roomId:'',deviceId:'',QType:QType.STATE,Utype:Utype.GATEWAY,Vtype:Vtype.P},
  "curve.P":{QType: QType.CURVE,Utype: Utype.GATEWAY,Vtype: Vtype.P,Rtype: Rtype.ToList,DateRange: DF.dateRange("d","dt").join("~")},
  "curve.K60.Energy":{beeId:'',roomId:'',deviceId:'',QType: QType.CURVE,Utype: Utype.GATEWAY,Vtype: Vtype.E,Rtype: Rtype.ToList,
    TimeScale: TimeScale.Hour,DateRange: DF.accCorrect(DF.dateRange("d"),"H","dt").join("~")}
}

export const Ftype = {
  I:"Integer",
  F:"Float",
  D:"Double"
};

export const Sex = {
  1:"男",
  2:"女",
  3:"其他"
}

export const Property = {
  PayloadURL : "http://beepower-bus.oss-cn-shanghai.aliyuncs.com"
}

export const NodeClazz = {
  PE:"PE",
  DT:"DT",
  VE:"VE",
  CE:"CE",
  OE:"OE"
}

export const ClazzMap = [
  {id:1,name:"物理实体",iconName:"cib-unity",clazz:NodeClazz.PE,secondary:[
      {id:1,name:"网关",iconName:"icon smart_power_network spn-wangguan",UtypeDetail:Utype.PE_GATEWAY,Utype:Utype.GATEWAY},
      {id:2,name:"房间",iconName:"icon smart_power_network spn-wodefangjian",UtypeDetail:Utype.PE_ROOM,Utype:Utype.ROOM},
      {id:3,name:"插座",iconName:"icon smart_power_network spn-chazuo",UtypeDetail:Utype.PE_SOCKET,Utype:Utype.TERMINAL},
      {id:4,name:"单相电表",iconName:"icon smart_power_network spn-dianbiao",UtypeDetail:Utype.PE_AMMETER,Utype:Utype.TERMINAL},
      {id:5,name:"三相电表",iconName:"icon smart_power_network spn-dianbiao1",UtypeDetail:Utype.PE_DT_AMMETER,Utype:Utype.TriUnit},
      {id:10,name:"温湿光强度",iconName: "icon smart_power_network spn-wenshidu", UtypeDetail: Utype.PE_Hum,Utype: Utype.TERMINAL},
      {id:6,name:"时钟",iconName:"icon smart_power_network spn-007-clock",UtypeDetail:Utype.PE_CLOCK,Utype:Utype.TERMINAL},
      {id:7,name:"单路开关",iconName:"icon smart_power_network spn-kaiguan",UtypeDetail:Utype.PE_LIGHT,Utype:Utype.TERMINAL},
      {id:8,name:"两路开关",iconName:"icon smart_power_network spn-dianyuankaiguan",UtypeDetail:Utype.PE_DOUBLE_LIGHT,Utype:Utype.TERMINAL},
      {id:9,name:"三路开关",iconName:"icon smart_power_network spn-cl-rl3",UtypeDetail:Utype.PE_TRIPLE_LIGHT,Utype:Utype.TERMINAL}
    ]
  },
  {id:2,name:"数字孪生体",iconName:"cil-object-ungroup",clazz:NodeClazz.DT,secondary:[
      {id:1,name:"网关",iconName:"icon smart_power_network spn-wangguan",UtypeDetail:Utype.DT_GATEWAY,Utype:Utype.GATEWAY},
      {id:2,name:"房间",iconName:"icon smart_power_network spn-wodefangjian",UtypeDetail:Utype.DT_ROOM,Utype:Utype.ROOM},
      {id:3,name:"插座",iconName:"icon smart_power_network spn-chazuo",UtypeDetail:Utype.DT_SOCKET,Utype:Utype.TERMINAL},
      {id:4,name:"单相电表",iconName:"icon smart_power_network spn-dianbiao",UtypeDetail:Utype.DT_AMMETER,Utype:Utype.TERMINAL},
      {id:5,name:"三相电表",iconName:"icon smart_power_network spn-dianbiao1",UtypeDetail:Utype.DT_DT_AMMETER,Utype:Utype.TERMINAL},
      {id:6,name:"时钟",iconName:"icon smart_power_network spn-007-clock",UtypeDetail:Utype.DT_CLOCK,Utype:Utype.TERMINAL},
      {id:7,name:"单路开关",iconName:"icon smart_power_network spn-kaiguan",UtypeDetail:Utype.DT_LIGHT,Utype:Utype.TERMINAL},
      {id:8,name:"两路开关",iconName:"icon smart_power_network spn-dianyuankaiguan",UtypeDetail:Utype.DT_DOUBLE_LIGHT,Utype:Utype.TERMINAL},
      {id:9,name:"三路开关",iconName:"icon smart_power_network spn-cl-rl3",UtypeDetail:Utype.DT_TRIPLE_LIGHT,Utype:Utype.TERMINAL}
    ]
  },
  {id:3,name:"虚拟实体",iconName:"cib-wireguard",clazz:NodeClazz.VE,secondary:[
      {id:301,name:"虚拟单相电表",iconName:"icon smart_power_network spn-dianbiao",UtypeDetail:Utype.VE_AMMETER,Utype:Utype.TERMINAL},
      {id:302,name:"虚拟三相电表",iconName:"icon smart_power_network spn-dianbiao1",UtypeDetail:Utype.VE_DT_AMMETER,Utype:Utype.TERMINAL},
      {id:303,name:"虚拟单开",iconName:"icon smart_power_network spn-kaiguan",UtypeDetail:Utype.VE_LIGHT,Utype:Utype.TERMINAL},
      {id:304,name:"虚拟双开",iconName:"icon smart_power_network spn-dianyuankaiguan",UtypeDetail:Utype.VE_DOUBLE_LIGHT,Utype:Utype.TERMINAL},
      {id:305,name:"虚拟三开",iconName:"icon smart_power_network spn-cl-rl3",UtypeDetail:Utype.VE_TRIPLE_LIGHT,Utype:Utype.TERMINAL},
      {id:306,name:"虚拟插座",iconName:"icon smart_power_network spn-chazuo",UtypeDetail:Utype.VE_SOCKET,Utype:Utype.TERMINAL},
      {id:307,name:"虚拟温湿度",iconName:"icon smart_power_network spn-wenshidu",UtypeDetail:Utype.VE_IRC,Utype:Utype.TERMINAL},
      {id:308,name:"虚拟遥测值",iconName:"icon smart_power_network spn-shuzi",UtypeDetail:Utype.VE_METRY,Utype:Utype.TERMINAL},
      {id:309,name:"虚拟遥信值",iconName:"icon smart_power_network spn-luoji",UtypeDetail:Utype.VE_SIGNAL,Utype:Utype.TERMINAL,thirdary:[
          {id:3081,name:"虚拟1状态",iconName:"icon smart_power_network spn-shuzi1",UtypeDetail:Utype.VE_NO1,Utype:Utype.TERMINAL},
          {id:3082,name:"虚拟2状态",iconName:"icon smart_power_network spn-shuzi2",UtypeDetail:Utype.VE_NO2,Utype:Utype.TERMINAL},
          {id:3083,name:"虚拟3状态",iconName:"icon smart_power_network spn-shuzi3",UtypeDetail:Utype.VE_NO3,Utype:Utype.TERMINAL},
          {id:3084,name:"虚拟4状态",iconName:"icon smart_power_network spn-shuzi4",UtypeDetail:Utype.VE_NO4,Utype:Utype.TERMINAL},
          {id:3085,name:"虚拟5状态",iconName:"icon smart_power_network spn-shuzi5",UtypeDetail:Utype.VE_NO5,Utype:Utype.TERMINAL},
          {id:3086,name:"虚拟6状态",iconName:"icon smart_power_network spn-shuzi6",UtypeDetail:Utype.VE_NO6,Utype:Utype.TERMINAL},
          {id:3087,name:"虚拟7状态",iconName:"icon smart_power_network spn-shuzi7",UtypeDetail:Utype.VE_NO7,Utype:Utype.TERMINAL},
          {id:3088,name:"虚拟8状态",iconName:"icon smart_power_network spn-shuzi8",UtypeDetail:Utype.VE_NO8,Utype:Utype.TERMINAL},
          {id:3089,name:"虚拟9状态",iconName:"icon smart_power_network spn-shuzi9",UtypeDetail:Utype.VE_NO9,Utype:Utype.TERMINAL}
        ]}
    ]
  },
  {id:4,name:"自定义实体",iconName:"cib-apache",clazz:NodeClazz.CE,secondary:[
      {id:401,name:"虚拟机器人",iconName:"icon smart_power_network spn-jiqiren",UtypeDetail:Utype.CE_ROBOT,Utype:Utype.TERMINAL}
    ]
  },
  {id:5,name:"其他实体",iconName:"cil-description",clazz:NodeClazz.OE,secondary:[
      {id:501,name:"时钟",iconName:"icon smart_power_network spn-007-clock",UtypeDetail:Utype.OE_CLOCK,Utype:Utype.TERMINAL},
      {id:502,name:"计数器",iconName:"icon smart_power_network spn-daojishi",UtypeDetail:Utype.OE_COUNTER,Utype:Utype.TERMINAL}
    ]
  }
]

export const ParamMap = {
  "常用参数":[
    {id:1,name:"有功功率",value:"P"},
    {id:2,name:"电压",value:"U"},
    {id:3,name:"电流",value:"I"},
    {id:4,name:"时电量",value:"E_H"},
    {id:5,name:"日电量",value:"E_d"},
    {id:6,name:"周电量",value:"E_w"},
    {id:7,name:"月电量",value:"E_M"},
    {id:8,name:"年电量",value:"E_y"}
  ],
  "可选参数":[
    {id:1,name:"无功功率",value:"Q"},
    {id:2,name:"功率因素",value:"PF"},
    {id:3,name:"频率",value:"F"},
    {id:4,name:"开关状态",value:"SWITCH"}
  ],
  "三相参数":[
    {id:1,name:"三相有功",value:"P(Tri)"},
    {id:2,name:"三相无功",value:"Q(Tri)"},
    {id:3,name:"三相电压",value:"U(Tri)"},
    {id:3,name:"三相电流",value:"I(Tri)"},
    {id:3,name:"三相功率因素",value:"PF(Tri)"},
    {id:3,name:"三相频率",value:"F(Tri)"},
    {id:3,name:"三相开关状态",value:"SWITCH(Tri)"}
  ],
  "单相历史曲线":[
    {id:1,name:"小时级(单相)功率",value:"P(h)_H"},
    {id:2,name:"小时级(单相)电压",value:"U(h)_H"},
    {id:3,name:"小时级(单相)电流",value:"I(h)_H"},
    {id:4,name:"小时级(单相)功率因素",value:"PF(h)_H"},
    {id:5,name:"日内(单相)功率",value:"P(d)_H"},
    {id:6,name:"日内(单相)电压",value:"U(d)_H"},
    {id:7,name:"日内(单相)电流",value:"I(d)_H"},
    {id:8,name:"日内(单相)功率因素",value:"PF(d)_H"},
    {id:9,name:"小时级(单相)日电量趋势",value:"E(d,H)_H"},
    {id:10,name:"日级(单相)周电量趋势",value:"E(w,d)_H"},
    {id:11,name:"日级(单相)月电量趋势",value:"E(M,d)_H"},
    {id:12,name:"周级(单相)年电量趋势",value:"E(y,w)_H"},
    {id:13,name:"月级(单相)年电量趋势",value:"E(y,M)_H"}
  ],
  "三相历史曲线":[
    {id:1,name:"小时级（三相）功率",value:"P(h)_TriH"},
    {id:2,name:"小时级（三相）电压",value:"U(h)_TriH"},
    {id:3,name:"小时级（三相）电流",value:"I(h)_TriH"},
    {id:4,name:"小时级（三相）功率因素",value:"PF(h)_TriH"},
    {id:5,name:"日内（三相）功率",value:"P(d)_TriH"},
    {id:6,name:"日内（三相）电压",value:"U(d)_TriH"},
    {id:7,name:"日内（三相）电流",value:"I(d)_TriH"},
    {id:8,name:"日内（三相）功率因素",value:"PF(d)_TriH"},
    {id:9,name:"小时级(三相)日电量趋势",value:"E(d,H)_TriH"},
    {id:10,name:"日级(三相)周电量趋势",value:"E(w,d)_TriH"},
    {id:11,name:"日级(三相)月电量趋势",value:"E(M,d)_TriH"},
    {id:12,name:"周级(三相)年电量趋势",value:"E(y,w)_TriH"},
    {id:13,name:"月级(三相)年电量趋势",value:"E(y,M)_TriH"}
  ],
  "预测曲线":[
    {id:1,name:"有功功率(日内)",value:"P(d)_F"},
    {id:2,name:"电量(日,时)",value:"E(d,H)_F"},
    {id:3,name:"电量(周,日)",value:"E(w,d)_F"},
    {id:4,name:"电量(月,日)",value:"E(M,d)_F"},
    {id:5,name:"电量(年,周)",value:"E(y,w)_F"},
    {id:6,name:"电量(年,月)",value:"E(y,M)_F"}
  ]
}

export const tou = [-1,-1,-1,-1,-1, // 0 ~ 6 时  谷时段
  0,0, //6~8时 平时段
  1,1,1, //8~11时 峰时段
  0,0,0,0,0,0,0, //11~18时 平时段
  1,1,1, //18~21时 峰时段
  0,//21~22时 平时段
  -1,-1//22~24时 谷时段
]

export const isInner = true
export const socketBroker = isInner?"ws://inner.beepower.com.cn:9001":"ws://test.beepower.com.cn:9001"
export const tcpBroker = isInner?"ws://inner.beepower.com.cn:1883":"ws://test.beepower.com.cn:1883"
